//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
	name: "CustomPagination",
	components: {},
	props: {
		navigate: Function,
		enableNext: Boolean,
		enablePrev: Boolean,
		totalPages: Number,
		currentPage: Number,
	},
	data() {
		return {
			
		}
	},
	computed: {
		
	},
	methods: {
		handleNavBtnClick(e, diff) {
			if (!e.target.matches("[disabled]")) this.navigate(diff);
		}
	},
	created() {
		
	}
}
